import { getUserInfo } from "src/hooks/useUser";

export function getService() {
	const userInfo = getUserInfo();

	return userInfo?.service;
}

function isPes() {
	return getService() === "PES";
}

export function isLek() {
	return getService() === "LEK";
}

export function hasServiceParam() {
	return !!getService();
}

export const getServiceName = () => {
	if (isPes()) {
		return "Pes";
	}

	return "Lek";
};

export default isPes;
